import { Component, EventEmitter, HostListener, inject, Inject, Input, OnInit, Output } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ImageCroppingComponent } from '@app/shared/components/image-cropping/image-cropping.component';
import { HeaderPopupComponent } from '../header-popup/header-popup.component';
import { UtilService } from '@app/shared/services/utils/util.service';
import { mobileFooterNavItems } from '@app/main/navigation-items';
import { MenuDisplayMode } from '../navigation-menu/navigation-menu.interface';
import { User } from '@app/shared/models/user.model';

@Component({
  selector: 'cm-header-profile-popup',
  templateUrl: './header-profile-popup.component.html',
  styleUrls: ['../header-popup/header-popup.component.scss', './header-profile-popup.component.scss'],
})
export class HeaderProfilePopupComponent extends HeaderPopupComponent implements OnInit {
  @Input() isSideNavStyle = false;
  @Input() user: Partial<User>;
  @Output() closeDialog = new EventEmitter<void>();
  @Output() closeImageCroppingMobileEmmiter = new EventEmitter<void>();
  @Output() openImageCroppingMobileEmmiter = new EventEmitter<void>();

  mobileNavigationItems = mobileFooterNavItems;
  profileDisplayMode = MenuDisplayMode.PROFILE;

  public isMobile = false;
  public data = inject(MAT_DIALOG_DATA) as any;

  constructor(
    public dialogRef: MatDialogRef<HeaderProfilePopupComponent>,
    private dialog: MatDialog
  ) {
    super(dialogRef);
  }

  @HostListener('window:resize', [])
  public onResize(): void {
    this.isMobile = UtilService.isMobileAndTabletSize();
  }

  ngOnInit(): void {
    this.onResize();
  }

  onCloseDialog(): void {
    this.closeDialog.emit();
  }

  loadImageCropper() {
    if (this.isMobile) {
      this.openImageCroppingMobileEmmiter.emit();
    } else {
      const open = this.dialog.open(ImageCroppingComponent, {
        panelClass: 'cm-mobile-pop-up',
        width: '700px',
        height: '447px',
      });

      open.afterClosed().subscribe(() => {
        if (!this.isSideNavStyle) {
          this.closeImageCroppingMobileEmmiter.emit();
        }
      });

      open.afterOpened().subscribe(() => {
        if (this.isMobile) {
          this.dialogRef.close();
        } else {
          this.closeDialog.emit();
        }
      });
    }
  }
}
